import { utils } from '@frontend/partviewer';
import type { UNITS } from '@frontend/partviewer/src/constants';
import type { MetaData } from '@frontend/partviewer/src/utils';

import {
  DisplayWrapper,
  DisplayTitle,
  DisplayEntry,
  DisplayEntryWrapper,
} from 'modules/common/viewer/components/ViewerDisplayElements';

const { formatEntityMetaData } = utils;

type MetaDataDisplayComponentProps = {
  displayScale: number;
  displayUnits: UNITS;
  dimensionalPrecision: number;
  metaData: MetaData;
  nativeUnits: UNITS;
};

const MetaDataDisplayComponent = ({
  displayScale,
  displayUnits,
  dimensionalPrecision,
  metaData,
  nativeUnits,
}: MetaDataDisplayComponentProps) => {
  const formattedMetaData = formatEntityMetaData(
    metaData,
    displayUnits,
    nativeUnits,
    dimensionalPrecision,
    displayScale,
  );
  return formattedMetaData.length > 0 ? (
    <DisplayWrapper>
      <DisplayTitle>Selection Data</DisplayTitle>
      {formattedMetaData.map((entry) => (
        <DisplayEntryWrapper key={entry.title}>
          <DisplayEntry>{`${entry.title}:`}</DisplayEntry>
          <DisplayEntry>{entry.payload}</DisplayEntry>
        </DisplayEntryWrapper>
      ))}
    </DisplayWrapper>
  ) : null;
};

export default MetaDataDisplayComponent;
